import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export default function IconDone({
    width = '18',
    height = '18',
    className,
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18 18"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                d="M15.75 5l-8 8-3.5-3.5C3.75 9 3 9 2.5 9.5s-.5 1.25 0 1.75l4.375 4.375c.25.25.5.375.875.375s.625-.125.875-.375L17.5 6.75c.5-.5.5-1.25 0-1.75s-1.25-.5-1.75 0z"
            />
        </svg>
    );
}
